/**
 * Permission task definitions for the Admin feature, used to control access
 * to employee list, groups, permissions, roles, and companies management.
 *
 * @module permissions/admin
 * @author Snowfly
 * @version 1.0.0
 */

/**
 * Permission map for the Admin feature.
 *
 * Each key is a resource and each nested key is an operation (view/create/update/delete).
 * The `task` string must exactly match the `name` field in the `permission_tasks` collection.
 *
 * @type {Object.<string, Object.<string, {task: string, type: string}>>}
 */
const admin = {
    employee_list: {
        view: {
            task: 'Employee List',
            type: 'view',
        },
        create: {
            task: 'Employee List',
            type: 'create',
        },
        update: {
            task: 'Employee List',
            type: 'update',
        },
        delete: {
            task: 'Employee List',
            type: 'delete',
        },
    },
    groups: {
        view: {
            task: 'Groups',
            type: 'view',
        },
        create: {
            task: 'Groups',
            type: 'create',
        },
        update: {
            task: 'Groups',
            type: 'update',
        },
        delete: {
            task: 'Groups',
            type: 'delete',
        },
    },
    permissions: {
        view: {
            task: 'Permissions',
            type: 'view',
        },
        create: {
            task: 'Permissions',
            type: 'create',
        },
        update: {
            task: 'Permissions',
            type: 'update',
        },
    },
    roles: {
        view: {
            task: 'Roles',
            type: 'view',
        },
        create: {
            task: 'Roles',
            type: 'create',
        },
        update: {
            task: 'Roles',
            type: 'update',
        },
        delete: {
            task: 'Roles',
            type: 'delete',
        },
    },
    companies: {
        view: {
            task: 'Companies',
            type: 'view',
        },
        create: {
            task: 'Companies',
            type: 'create',
        },
        update: {
            task: 'Companies',
            type: 'update',
        },
        delete: {
            task: 'Companies',
            type: 'delete',
        },
    }
};
export default admin;
